import { FileUploadResponse } from '@wix/answers-api';
import { uploadBase64File } from '../../api';
import { RawChatMessage, RawChatTimelineEvent } from './chat-timeline/types';

export const uploadFile = (apiUrl: string, file: File, cb: (percent: number) => void) => {
	const fileReader = new FileReader();

	return new Promise<FileUploadResponse>((resolve, reject) => {
		fileReader.addEventListener('load', async () => {
			try {
				const result = await uploadBase64File(apiUrl, fileReader.result, undefined, cb, false);
				resolve(result);
			} catch (e) {
				console.info(e);
				reject(e);
			}
		});

		fileReader.readAsDataURL(file);
	});
};

export const getShortenedNumber = (count: number) => {
	const KB = 1024;
	const MB = 1024 * 1024;
	if (count >= MB) {
		const dividedCount = count / MB;
		const shortenedCount = Math.floor(dividedCount);
		return `${shortenedCount} MB`;

	} else if (count >= KB) {
		const dividedCount = count / KB;
		const shortenedCount = Math.floor(dividedCount);
		return `${shortenedCount} KB`;
	}
	return `${count}`;
};

export const AttachmentTypes = {
	IMAGE: 'image',
	XLS: 'xls',
	DOC: 'doc',
	PDF: 'pdf',
	UNKNOWN: 'unknown'
};

export const ErrorType = {
	SIZE: 'size',
	TYPE: 'type',
	UNKNOWN: 'unknown',
	NONE: 'none'
};

export const getContentType = (contentType: string) => {
	if (contentType.includes('xls')
		|| contentType.includes('sheet')
		|| contentType.includes('xlsx')
		|| contentType.includes('xlsm')
		|| contentType.includes('xltx')) {
		return AttachmentTypes.XLS;
	}
	if (contentType.includes('pdf')) {
		return AttachmentTypes.PDF;
	}
	if (contentType.includes('doc')
	|| contentType.includes('.docx')
	|| contentType.includes('.dot')
	|| contentType.includes('.dotx')) {
		return AttachmentTypes.DOC;
	}
	if (contentType.includes('image')) {
		return AttachmentTypes.IMAGE;
	}
	return AttachmentTypes.UNKNOWN;
};

export const isMessage = (messageOrEvent: RawChatMessage | RawChatTimelineEvent): messageOrEvent is RawChatMessage => {
	return (messageOrEvent as RawChatMessage).chatMessageType !== undefined;
};
